import { render } from "./LocationTabs.vue?vue&type=template&id=11fb971a&ts=true"
import script from "./LocationTabs.vue?vue&type=script&lang=ts"
export * from "./LocationTabs.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__